import { SigLabel } from '../components/atelier';

export function How() {
  return (
    <section id="how" className="container section">
      <div className="block-head">
        <div>
          <SigLabel>How it works</SigLabel>
          <h2>
            Three steps. <em>One draft.</em>
          </h2>
        </div>
        <p className="lede">
          The flow is the same whether you&rsquo;re sketching a fastener or a
          flying-wing electronics bay. Type, generate, hand off. Or stay in
          the chat and tweak.
        </p>
      </div>

      <div className="how">
        <div className="how-card">
          <div className="how-num">01 · Describe</div>
          <h3>
            Talk like an <em>engineer.</em>
          </h3>
          <p>
            One sentence will do. Bolt patterns, fits, shaft sizes, mounting
            flanges: the drafter is tuned for the way mechanical engineers
            actually talk. Underspecify and it asks. Over-specify and it locks
            parameters.
          </p>
          <div className="visual">
            <span style={{ fontStyle: 'italic', fontFamily: 'var(--font-serif)', textTransform: 'none', letterSpacing: 0, fontSize: 13, color: 'var(--fg-muted)' }}>
              &ldquo;1:5 planetary reducer for a NEMA 17 stepper.&rdquo;
            </span>
          </div>
        </div>

        <div className="how-card">
          <div className="how-num">02 · Generate</div>
          <h3>
            Draft, build, <em>deliver.</em>
          </h3>
          <p>
            The drafter turns the spec into a parametric part. If something
            is missing, it asks. If it doesn&rsquo;t know a standard or a
            dimension, it looks it up. The result is a 3D preview and a
            clean STEP, usually in under a minute.
          </p>
          <div className="visual" style={{ alignItems: 'flex-start', textAlign: 'left', padding: '12px 14px' }}>
            <pre className="mono" style={{ margin: 0, fontSize: 9.5, lineHeight: 1.5, whiteSpace: 'pre-wrap', color: 'var(--fg-muted)', textTransform: 'none', letterSpacing: 0 }}>
{`drafting     →  ok
building     →  ok
preview      →  ok
ready        →  bolt.step`}
            </pre>
          </div>
        </div>

        <div className="how-card">
          <div className="how-num">03 · Tweak or hand off</div>
          <h3>
            STEP out, <em>or stay in.</em>
          </h3>
          <p>
            Drag a slider. Every dimension is a named parameter. Or download
            the STEP and keep going in CATIA, Creo, SolidWorks, Onshape, or
            FreeCAD, with the rough work already done for you.
          </p>
          <div className="visual">
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '0.16em' }}>
              <span style={{ color: 'var(--accent)' }}>↓</span> bolt-50mm.step ·
              4.7&nbsp;KB
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
